import { Maybe } from '@atlassian/cssxp-typescommon';
import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';
import { QuoteMetaData } from '@css-xp/graphtypes/src/generated-types-sxp';
import { AxiosError } from 'axios';
import { CCPVaidationError } from '../ccp-client/ccp';

const client = createAxiosClient({ baseURL: '/api/1/quotes' }, ServiceProxyMap.PPC_BFF);

interface QuoteOrderRequestPayload {
  source: string;
  orderId: string;
  quote: {
    id: string;
    version: Maybe<number> | undefined;
  };
  metadata?: Maybe<QuoteMetaData> | undefined;
}

export const placeQuoteOrderV2 = async (
  orderPayload: QuoteOrderRequestPayload,
  transactionAccountId: string,
  invoiceGroupId: string,
  isBillingProfileChanged: boolean
) => {
  const payload = {
    orderPayload,
    transactionAccountId,
    invoiceGroupId,
    isBillingProfileChanged,
  };

  try {
    const response = await client.post('/place-order', payload, {
      validateStatus: (status) => status === 200,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (err) {
    if (err instanceof AxiosError && err?.response?.data?.payload) {
      const { title, items, code } = err.response.data.payload;
      throw new CCPVaidationError(title, items, code);
    }
    throw err;
  }
};
